import React from "react";
import { useSelector, useDispatch } from "react-redux";

export const Counter = () => {
  const todos = useSelector((state) => state.counter);
  const dispatch = useDispatch();
  return (
    <div style={{margin:"1rem"}}>
        <h3>Counter Component:</h3>
      <h6>A simple counter component runs on Redux state,</h6>
      <div style={{textAlign:"center"}}>
        <button
          style={{
            backgroundColor: "royalblue",
            margin: "0.5rem",
            padding: "0.8rem",
            borderRadius: "1rem",
            color: "white",
            outline: "none",
          }}
          onClick={() => dispatch({ type: "INCREMENT" })}
        >
          +
        </button>
        <button
          style={{
            backgroundColor: "royalblue",
            margin: "0.5rem",
            padding: "0.8rem",
            borderRadius: "1rem",
            color: "white",
            outline: "none",
          }}
          onClick={() => dispatch({ type: "DECREMENT" })}
        >
          -
        </button>
      </div>
    </div>
  );
};
